import React from 'react';
import { Permission, Role } from 'src/types';
import PermissionsList from './List';

interface Props {
	feature: any;
	showAddButton?: boolean;
	showRemoveButton?: boolean;
	onAddPermission?: (permission: Permission) => void;
	onRemovePermission?: (permission: Permission, role: Role) => void;
}

export function PermissionsGroups(props: Props) {
	const { feature, onRemovePermission, onAddPermission, showAddButton, showRemoveButton } = props;
	const categories = Object.keys(feature);

	return (
		<div>
			{categories.map((category) => {
				const permissions = feature[category];

				return (
					<div key={category}>
						<h4>{category}</h4>
						<div>
							{permissions.length > 0 ? (
								<PermissionsList
									permissions={permissions}
									onRemovePermission={onRemovePermission}
									onAddPermission={onAddPermission}
									showAddButton={showAddButton}
									showRemoveButton={showRemoveButton}
								/>
							) : (
								<div style={{ marginBottom: '30px' }}>nessun permesso</div>
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default PermissionsGroups;
